import { createApi } from '@reduxjs/toolkit/query/react'

import envConfig from '~/configs/env'

import anonymizingFetchBaseQuery from '../anonymizingBaseQuery'
import { prepareAuthHeaderWithoutOrg } from '../headers'

// Requests are scoped to the signed-in principal and never name the cloaked organization.
const baseQuery = anonymizingFetchBaseQuery({
  baseUrl: envConfig.serviceUrls.derSimulator,
  prepareHeaders: prepareAuthHeaderWithoutOrg
})

// eslint-disable-next-line import/prefer-default-export
export const api = createApi({
  reducerPath: 'derSimulatorApi',
  baseQuery,
  endpoints: () => ({})
})
